import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
// import { withTranslation } from 'react-i18next';
// import i18n from 'i18next';
import './barCharts.css';
import qs from 'query-string';
import { apis } from '../../api/index.js';
import { Form, Checkbox, Button, Icon, message, Tabs, Spin } from 'antd';
import btnSubmit from '../../imgs/btn-submit.png';
import { EditFile, formatDate } from '../../utils';
const { TabPane } = Tabs;

class Screening extends Component {
  static propTypes = {
    objectUid: PropTypes.string,
    showHeatMap: PropTypes.func,
    changeMenuTaskData: PropTypes.func,
    showScreening: PropTypes.bool,
    tubeStudyDetail: PropTypes.object,
  };

  constructor(props) {
    super(props);
    const search = qs.parse(window.location.search);
    this.state = {
      from: search.from,
      reviewResult: null,
      tubeId: search.tubeId,
      detail: {},
      reviewDictList: [],
      from1: search.from1,
      showScreening: true,
      type: search.type,
      isLoading: false,
    };
  }

  componentDidUpdate(prevProps) {
    const { tubeStudyDetail } = this.props;
    if (this.props.showScreening !== prevProps.showScreening) {
      this.setState({ showScreening: this.props.showScreening });
    }

    if (tubeStudyDetail !== prevProps.tubeStudyDetail) {
      this.setTubeStudyDetail(tubeStudyDetail);
    }
  }

  componentDidMount() {}

  setTubeStudyDetail = detail => {
    const { from1, type } = this.state;
    const dicomList = detail.dicomList;
    const canReview = dicomList.filter(item => item.chestPa).length > 0;
    let reviewResult = [];
    if (from1 === 'review') {
      let data = {};
      if (type === '1') {
        //组织一审数据
        data = detail;
      } else if (type === '2') {
        //组织二审数据
        data = detail.reviewList[0];
        data.dicomList = detail.dicomList;
      } else if (type === '3') {
        //组织三审数据
        data = detail.reviewList[1];
        data.dicomList = detail.dicomList;
      } else if (type === 'V') {
        //组织查看数据
        const reviewList = detail.reviewList || [];
        const data3 = {
          imageResult: detail.imageResult,
          reviewCode: detail.reviewCode,
          reviewStartTime: detail.reviewStartTime,
          reviewText: detail.reviewText,
          reviewTime: detail.reviewTime,
          reviewType: 1,
          reviewUpdateTime: detail.updateTime,
          reviewUser: detail.reviewUser,
          reviewUserName: detail.reviewUserName,
          state: detail.state,
          tubeStudyId: detail.id,
          updateReviewUser: detail.updateReviewUser,
        };
        reviewList.splice(0, 0, data3);
        data = detail;
        data.reviewList = reviewList;
      }
      if (data.state === 20 && canReview) {
        //审核中
        const time = formatDate(new Date(), 'YYYY-MM-DD HH:mm:ss');
        window.localStorage.setItem('changeMenuTaskFlag', time);
        window.localStorage.setItem('updateIntelligentReview', new Date());
      } else {
        this.showHeatMap(data);
      }
      reviewResult = data.reviewCode ? data.reviewCode.split(',') : [];
      this.setState({ detail: data, reviewResult });
    } else if (from1 === 'view') {
      const data = detail;
      if (data.state === -1) data.reviewText = '胸片结核影像阴性';
      else if (data.state === 20) data.state = 10;
      else if (data.state === 30 && canReview) this.showHeatMap(detail);

      reviewResult = data.reviewCode ? data.reviewCode.split(',') : [];
      this.setState({ detail: data, reviewResult });
    }
    apis.tubeReviewDict().then(res => {
      if (res.code === '0') {
        this.setState({ reviewDictList: res.data });
        this.getReviewList(reviewResult);
      }
    });
  };

  showHeatMap = data => {
    const dicomList = data.dicomList;
    const chestPaList = dicomList.filter(item => item.chestPa);
    let reviewCode = JSON.stringify(data.reviewCode);
    let isYang = reviewCode.indexOf('0') >= 0 ? false : true;
    if (chestPaList.length > 0 && isYang) {
      let heatmap,
        value = 0;
      chestPaList.forEach(item => {
        if (value < item.confidence) {
          value = item.confidence;
          heatmap = item;
        }
      });
      this.props.showHeatMap(heatmap, data.studyUid);
    }
  };

  checkDisabled = (checked, array) => {
    let disabled = false;
    for (let i = 0; i < array.length; i++) {
      if (checked.indexOf(array[i]) >= 0) disabled = true;
      continue;
    }
    return disabled;
  };

  getReviewList = (checked = []) => {
    const radioStyle = { display: 'block' };
    const { reviewDictList } = this.state;
    const html = [];

    reviewDictList.forEach((item, index) => {
      let disabled = false;
      if (checked.length > 0) {
        let array = [];
        if (item.code === '0') {
          array = ['1', '2', '3', '4', '5'];
        } else if (item.code === '1') {
          array = ['0', '2', '3', '4'];
        } else if (item.code === '2') {
          array = ['0', '1', '3', '4'];
        } else if (item.code === '3') {
          array = ['0', '1', '2', '4'];
        } else if (item.code === '4') {
          array = ['0', '1', '2', '3'];
        } else if (item.code === '5') {
          array = ['0'];
        }
        disabled = this.checkDisabled(checked, array);
      }
      html.push(
        <Checkbox
          style={radioStyle}
          value={item.code}
          key={index}
          disabled={disabled}
        >
          {item.name}
        </Checkbox>
      );
    });
    this.setState({ reviewDictOption: html });
  };

  radioOnChange = value => {
    this.setState({ reviewResult: value });
    this.getReviewList(value);
  };

  submitResult = () => {
    const { reviewResult, detail, type } = this.state;
    const time = formatDate(new Date(), 'YYYY-MM-DD HH:mm:ss');
    window.localStorage.setItem('changeMenuTaskFlag', time);
    if (reviewResult !== null && reviewResult.length > 0) {
      this.setState({ isLoading: true });
      if (type !== '1') {
        const post = {
          id: detail.id,
          tubeStudyId: detail.tubeStudyId,
          reviewType: type,
          reviewCode: reviewResult.join(','),
        };
        apis.savePrivatReview(post).then(res => {
          this.setState({ isLoading: false });
          if (res.code === '0') {
            window.localStorage.setItem('updateIntelligentReview', new Date());
            message.success('提交成功');
            detail.state = 30;
            this.setState({ detail });
          } else {
            message.error(res.message);
          }
        });
      } else {
        const post = {
          id: detail.id,
          reviewCode: reviewResult.join(','),
        };
        apis.tubeStudySave(post).then(res => {
          this.setState({ isLoading: false });
          if (res.code === '0') {
            window.localStorage.setItem('updateIntelligentReview', new Date());
            message.success('提交成功');
            detail.state = 30;
            this.setState({ detail });
          } else {
            message.error(res.message);
          }
        });
      }
    } else {
      message.warning('请选择一条审核意见');
    }
  };
  quietReview = () => {
    const { detail, type, tubeId } = this.state;
    let url;
    if (type === '1') {
      url = apis.tubeStudyQuitReview(detail.id);
    } else {
      url = apis.quitPrivateReview(tubeId, type);
    }
    this.setState({ isLoading: true });
    url.then(res => {
      this.setState({ isLoading: false });
      if (res.code === '0') {
        message.success('操作成功');
        window.localStorage.setItem('updateIntelligentReview', new Date());
        setTimeout(function() {
          window.close();
        }, 1000);
      } else {
        message.error(res.message);
      }
    });
  };

  getNoResult = () => {
    return (
      <div className="no-result">
        <p className="edit-icon">
          <EditFile />
        </p>
        <p className="tip">暂无诊断结果，请稍后再查看</p>
      </div>
    );
  };

  getDoctorName = name => {
    return (
      <div className="doctor">
        审核医生：
        <span>{name || '--'}</span>
      </div>
    );
  };

  getReviewResult = text => {
    return <div className="text">{text || '--'}</div>;
  };
  render() {
    // -1免审，10待审，20审核中，30已审，31修改中
    const { detail, showScreening, from1, type, isLoading } = this.state;
    const status = detail.state;
    const list = detail.reviewList || [];

    return (
      <div
        className="screening"
        style={{ display: showScreening ? '' : 'none' }}
      >
        {isLoading && (
          <div className="spin-box-bg">
            <Spin indicator={<Icon type="loading" spin />} />
          </div>
        )}
        <div className="screening-review">
          <div className="title">
            肺结核筛查结果
            {from1 === 'review' && (
              <span className="status">
                {status === 20 && '...审核中'}
                {status === 30 && '已审核'}
                {status === 31 && '...修改中'}
              </span>
            )}
          </div>
          <div className="content">
            {from1 === 'view' ? (
              <>
                {/* 未筛查 */}
                {(status === 10 || status === 20) && this.getNoResult()}
                {(status === -1 || status === 30) && (
                  <>
                    {this.getReviewResult(detail.reviewText)}
                    <div style={{ height: 10 }}></div>
                  </>
                )}
                {status >= 20 && this.getDoctorName(detail.reviewUserName)}
              </>
            ) : (
              <>
                {type === 'V' ? (
                  <>
                    {status === 10 || status === 20 ? (
                      this.getNoResult()
                    ) : (
                      <Tabs type="card" className="screening-result">
                        {list.map((item, index) => {
                          const titleArray = ['', '一审', '二审', '三审'];
                          let title = titleArray[item.reviewType];
                          if (item.state === 30)
                            return (
                              <TabPane TabPane tab={title} key={index}>
                                {this.getReviewResult(item.reviewText)}
                                {this.getDoctorName(item.reviewUserName)}
                              </TabPane>
                            );
                          return null;
                        })}
                      </Tabs>
                    )}
                    {/* 审核结果 */}
                  </>
                ) : (
                  <>
                    {/* 未筛查 */}
                    {status === 10 && this.getNoResult()}
                    {/* 审核中-start */}
                    {(status === 20 || status === 30) && (
                      <Checkbox.Group
                        onChange={this.radioOnChange}
                        value={this.state.reviewResult}
                      >
                        {this.state.reviewDictOption}
                      </Checkbox.Group>
                    )}
                    {/* 审核中-end */}
                    {status >= 20 && this.getDoctorName(detail.reviewUserName)}
                  </>
                )}
              </>
            )}
          </div>

          {type !== 'V' && from1 === 'review' ? (
            <div className="buttons">
              {status === 20 && (
                <Button className="cancel" onClick={this.quietReview}>
                  <Icon type="close-circle" theme="filled" />
                  取消操作
                </Button>
              )}
              {status > 10 && (
                <Button className="submit" onClick={this.submitResult}>
                  <img alt="" src={btnSubmit} />
                  &nbsp; 提交审核意见
                </Button>
              )}
            </div>
          ) : null}
        </div>
      </div>
    );
  }
}

export default withRouter(Form.create()(Screening));
